import { APP_INITIALIZER, NgModule, Optional, RendererFactory2, SkipSelf } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AnalyticsService } from './services';
import { amplitudeInitializer } from './init';
import { AmplitudeService } from './services/amplitude.service';
import { hotJarFactory } from './init/hotjar.factory';

@NgModule({
  declarations: [],
  imports: [CommonModule],
  providers: [
    AnalyticsService,
    AmplitudeService,
    {
      provide: APP_INITIALIZER,
      multi: true,
      deps: [RendererFactory2],
      useFactory: hotJarFactory,
    },
    {
      provide: APP_INITIALIZER,
      multi: true,
      useFactory: amplitudeInitializer,
    },
  ],
})
export class AnalyticsModule {
  public constructor(@Optional() @SkipSelf() module?: AnalyticsModule) {
    if (module) {
      throw new Error('AnalyticsModule is already loaded. Import it in the AppModule only');
    }
  }
}
